export const DatePickerFormat = 'MMM D, YYYY';
export const RegexDiscountType = /^\d{1,2}% Off$/i;

// NOTE: matches upper/lower am/PM
export const Regex12HourClock = /^(1[0-2]|0?[1-9]):([0-5]?[0-9])( ?[aApP][mM])?$/;

export const regexObjectId =
  /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/;
